import { Card } from "./ui/card";
import { motion } from "framer-motion";

export function AboutSection() {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            About <span className="text-orange-600">AdHub</span>
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-orange-500 to-orange-700 mx-auto mb-8"></div>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-12 items-center max-w-6xl mx-auto">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <div className="space-y-6">
              <div className="flex items-center space-x-4 mb-6">
                <div className="bg-orange-100 rounded-full p-3">
                  <div className="w-6 h-6 bg-orange-600 rounded-full"></div>
                </div>
                <span className="text-orange-600 font-semibold text-lg">Established 2019</span>
              </div>
              
              <p className="text-lg text-gray-700 leading-relaxed">
                AdHub is a hybrid team of marketing experts, creatives, and developers. 
                We combine creativity, data, and technology to deliver measurable results that drive real business growth.
              </p>

              <div className="bg-gradient-to-r from-orange-50 to-orange-100 rounded-2xl p-6 border-l-4 border-orange-600">
                <h4 className="font-semibold text-gray-900 mb-2">Our Mission</h4>
                <p className="text-gray-700">
                  To blend creativity, data, and technology to create marketing campaigns 
                  with real impact and measurable outcomes for every client.
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
            className="grid grid-cols-2 gap-4"
          >
            <Card className="overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300">
              <img 
                src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=300&h=200&fit=crop" 
                alt="AdHub team collaboration" 
                className="w-full h-48 object-cover"
              />
            </Card>
            <Card className="overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300 mt-8">
              <img 
                src="https://images.unsplash.com/photo-1515187029135-18ee286d815b?w=300&h=200&fit=crop" 
                alt="Behind the scenes work" 
                className="w-full h-48 object-cover"
              />
            </Card>
            <Card className="overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300 col-span-2">
              <img 
                src="https://images.unsplash.com/photo-1556761175-b413da4baf72?w=600&h=200&fit=crop" 
                alt="Team brainstorming session" 
                className="w-full h-32 object-cover"
              />
            </Card>
          </motion.div>
        </div>
      </div>
    </section>
  );
}